import React from 'react';

import { PageLayout } from 'src/components/common';
import { pageLayoutPaperSx } from 'src/constants/styles';
import { ClearVerifyStaffInviteModalClearVerifyAdmin } from 'src/modals/clearVerifyStaff';
import { ResendInviteModal } from 'src/modals/invite';
import { TableDataProvider } from 'src/providers/TableDataProvider';

import { ClearVerifyStaffTableInner } from './components';

export const ClearVerifyStaffTableClearVerifyAdmin: React.FC = () => {
  return (
    <PageLayout titleContent="Clear Verify Staff" paperSx={pageLayoutPaperSx}>
      <TableDataProvider>
        <ClearVerifyStaffTableInner />
      </TableDataProvider>
      <ClearVerifyStaffInviteModalClearVerifyAdmin />
      <ResendInviteModal />
    </PageLayout>
  );
};
